module.exports = __webpack_public_path__ + "static/media/esim_graph2_jpn.1ed08642.png";